module.exports = __webpack_public_path__ + "static/img/7.21eb2ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/zombs/7.png
// module id = Nu2x
// module chunks = 35